<template>
  <div class="">
    <div class="ui three unstackable top attached mini steps">
      <div
        :class="['step', getStepStatus(index, step)]"
        v-for="(step, index) in steps"
        :key="index"
      >
        <i :class="step.icon"></i>
        <div class="content">
          <div class="title">{{ step.title }}</div>
          <div class="description">{{ step.subtitle }}</div>
        </div>
      </div>
    </div>
    <div :class="['ui', 'attached', 'segment', 'animated-content', getLoading]">
      <transition
        :enter-active-class="enterAnimation"
        :leave-active-class="leaveAnimation"
        mode="out-in"
      >
        <!--If keep alive-->
        <keep-alive v-if="keepAliveData">
          <component
            :is="steps[currentStep.index].component"
            @next="nextStep"
            @loading="isLoading"
          ></component>
        </keep-alive>
        <!--If not show component and destroy it in each step change-->
        <component v-else :is="steps[currentStep.index].component"></component>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      default: function() {
        return [
          {
            icon: 'mail',
            name: 'first',
            title: 'Sample title 1',
            subtitle: 'Subtitle sample'
          },
          {
            icon: 'report_problem',
            name: 'second',
            title: 'Sample title 2',
            subtitle: 'Subtitle sample'
          }
        ];
      }
    },
    keepAlive: {
      type: Boolean,
      default: true
    },
    reset: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentStep: {},
      previousStep: {},
      nextButton: {},
      canContinue: false,
      finalStep: false,
      loading: false,
      stepsStatus: [],
      keepAliveData: this.keepAlive
    };
  },
  computed: {
    enterAnimation() {
      if (this.currentStep.index < this.previousStep.index) {
        return 'animated quick fadeInLeft';
      } else {
        return 'animated quick fadeInRight';
      }
    },
    leaveAnimation() {
      if (this.currentStep.index > this.previousStep.index) {
        return 'animated quick fadeOutLeft';
      } else {
        return 'animated quick fadeOutRight';
      }
    },
    getLoading() {
      if (this.loading) {
        return 'loading';
      } else {
        return '';
      }
    }
  },
  methods: {
    getStepStatus(index, step) {
      if (this.currentStep.index === index) {
        return 'active';
      } else {
        return this.stepsStatus[index];
      }
    },
    activateStep(index, back = false) {
      if (this.steps[index]) {
        this.previousStep = this.currentStep;
        this.currentStep = {
          name: this.steps[index].name,
          index: index
        };
        if (index + 1 === this.steps.length) {
          this.finalStep = true;
        } else {
          this.finalStep = false;
        }
      }
    },
    nextStep() {
      this.stepsStatus[this.currentStep.index] = 'completed';
      let currentIndex = this.currentStep.index + 1;
      this.activateStep(currentIndex);
    },
    isLoading: function(value) {
      this.loading = value;
    },
    init() {
      this.activateStep(0);
      this.stepsStatus = this.steps.map((step, index) => {
        return 'disabled';
      });
    }
  },
  created: function() {
    this.init();
  }
};
</script>

<style lang="css" scoped>
.animated-content {
  overflow: hidden;
  margin: 1.5rem 0;
}
</style>
